const StarItem = ({ Svg, text, className }) => {
    return (
      <div className={`star-item ${className}`}>
        <Svg className="star-bg" />
        <div className="star-text">{text}</div>
      </div>
    );
  };

  export default StarItem;